import React from 'react'
import { Box, Modal } from '@mui/material'
import { t } from 'i18next'
import { ExclamationTriangleFill } from 'react-bootstrap-icons'
import closeIcon from 'Assets/Images/Login/no.svg'
import 'Components/GenericModal/genericModal.css'
import styles from './missingPriceModal.module.css'

// Mirrors GenericModal's look, but lays out the product list itself:
// GenericModal renders its texts inside headings.
export default function MissingPriceModal({ pending, onResolve }) {
  const products = pending?.products ?? []
  const title = pending?.warehouseName
    ? t('MISSING_PRICE_MODAL.TITLE', { branch: pending.warehouseName })
    : t('MISSING_PRICE_MODAL.TITLE_NO_BRANCH')

  return (
    <Modal
      open={!!pending}
      onClose={() => onResolve(false)}
      data-testid="modal-missing-price">
      <Box
        className={`modal-box-generic-modal-caution2 ${styles.box}`}
        role="alertdialog"
        aria-labelledby="missing-price-title"
        aria-describedby="missing-price-description missing-price-count"
        data-testid="container-missing-price-modal">
        <div className="closing-button-less-padding">
          <img
            src={closeIcon}
            onClick={() => onResolve(false)}
            alt="close"
            data-testid="btn-close-missing-price"
          />
        </div>
        <div
          className={styles.content}
          data-testid="container-missing-price-content">
          <ExclamationTriangleFill
            className={styles.icon}
            aria-hidden
            data-testid="icon-missing-price-caution"
          />
          <h2
            id="missing-price-title"
            className={styles.title}
            data-testid="text-missing-price-title">
            {title}
          </h2>
          <p
            id="missing-price-description"
            className={styles.text}
            data-testid="text-missing-price-description">
            {t('MISSING_PRICE_MODAL.DESCRIPTION')}
          </p>
          <p
            id="missing-price-count"
            className={styles.count}
            data-testid="text-missing-price-count">
            {t('MISSING_PRICE_MODAL.COUNT', { count: products.length })}
          </p>
          <ul className={styles.list} data-testid="list-missing-price">
            {products.map((product, index) => (
              <li
                className={styles.item}
                key={product.LineNum ?? product.ProductId}
                data-testid={`item-missing-price-${index}`}>
                <span
                  className={styles.name}
                  data-testid={`text-missing-price-name-${index}`}>
                  {product.ProductName || product.ProductId}
                </span>
                {product.Sku && (
                  <span
                    className={styles.sku}
                    data-testid={`text-missing-price-sku-${index}`}>
                    {product.Sku}
                  </span>
                )}
              </li>
            ))}
          </ul>
          <p
            className={styles.question}
            data-testid="text-missing-price-question">
            {t('MISSING_PRICE_MODAL.QUESTION')}
          </p>
        </div>
        <div
          className="modal-content-buttons"
          data-testid="container-missing-price-buttons">
          <button
            type="button"
            onClick={() => onResolve(true)}
            data-testid="btn-confirm-missing-price">
            {t('MISSING_PRICE_MODAL.CONFIRM')}
          </button>
          <button
            type="button"
            onClick={() => onResolve(false)}
            data-testid="btn-cancel-missing-price">
            {t('MISSING_PRICE_MODAL.CANCEL')}
          </button>
        </div>
      </Box>
    </Modal>
  )
}
